export default "__VITE_ASSET__DyqNndsk__"